import _ from 'lodash'
import { ENTRIES_LOADED } from '../constants';

const initialState = {byContentfulId: {}, all:[]};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.venue) {
                const result = initialState;
                Object.keys(action.entries.venue).map(key => {
                    result.byContentfulId[key] = action.entries.venue[key];
                    result.all.push(action.entries.venue[key]);
                })
                return result
            }
            break;
    }
    return state;
}
